import React from "react";

function Footer() {
  return (
    <div className="mx-auto w-full text-center">
      <p className="text-xl">
        Made with ❤️ by{" "}
        <a
          className="hover:text-gray-400"
          href="https://www.linkedin.com/in/muskan-k-323b15280/"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          Muskan{" "}
        </a>
      </p>
    </div>
  );
}

export default Footer;
